export class TransportManagementDefaultProfileSetToggle {
  public static readonly type = '[TransportManagementDefaultProfile] Set Default Profile Toggle';
  constructor(public payload: { profileId: number; isDefault: boolean }) {}
}

export class TransportManagementDefaultProfileLoad {
  public static readonly type = '[TransportManagementDefaultProfile] Load Default Profile';
}

export class TransportManagementDefaultProfileAffectedUsersLoad {
  public static readonly type = '[TransportManagementDefaultProfile] Load Default Profile Affected Users';
  constructor(public payload: number) {}
}

export class TransportManagementDefaultProfileInitialState {
  public static readonly type = '[TransportManagementDefaultProfile] Set Initial State';
}
